import React from 'react';

import { takeEvery, call } from 'redux-saga/effects';

import ToastMessage, { toastify } from '../components/shared/Toasts';

import { SUBMISSION_EDIT_SUCCESS, SUBMISSION_CREATE_SUCCESS } from '../constants/submission';

const coverages = {
    standard: 'Standard Coverage',
    conditional: 'Conditional Coverage',
    biExcluded: 'BI Excluded',
    deductibleWarranty: 'Deductible Warranty for One Hired Contractor'
};

// TODO: Move these components "somewhere else" - you got UI in my Business Logic!

const PricedSubmissionMsg = ({ submissionType }) => {
    return (
        <ToastMessage icon="check">
            You have been emailed a pricing summary of {submissionType} .
            <br />
            Quote and policy specimen are available for download from the submission list.
        </ToastMessage>
    );
};

const PricedSubmissionRequoteMsg = ({ submissionType, coverageType }) => {
    return (
        <ToastMessage icon="check">
            You have been emailed a pricing summary of {submissionType} {submissionType === 'OI' ? coverageType : ''}.
            <br />
            Quote and policy specimen are available for download from the submission list.
        </ToastMessage>
    );
};

const ReferredSubmissionMsg = () => {
    return (
        <ToastMessage icon="info-circle">
            Pricing will be emailed after an underwriter reviews your submission. Please email your
            assigned underwriter with any questions.
        </ToastMessage>
    );
};

const PendingClearanceSubmissionMsg = () => {
    return (
        <ToastMessage icon="info-circle">
            Pricing will be emailed only if clearance is confirmed. Please email your assigned
            underwriter with any questions.
        </ToastMessage>
    );
};

function* submissionEditSuccess(action) {
    if (action.value.result === 'submission_failed_referral_rules_validation') {
        yield call(toastify.info, <ReferredSubmissionMsg />, { autoClose: 10000 });
    } else if (action.value.result === 'submission_failed_clearance') {
        yield call(toastify.info, <PendingClearanceSubmissionMsg />, { autoClose: 10000 });
    } else if (action.value.result === 'submission_drafted') {
        //no action needed
    } else if (action.value.quoteCount === 0) {
        yield call(
            toastify.success,
            <PricedSubmissionMsg submissionType={action.value.submission.type.toUpperCase()} />,
            { autoClose: 10000 }
        );
    } else if (action.value.submission.type !== 'oi') {
        yield call(
            toastify.success,
            <PricedSubmissionRequoteMsg
                submissionType={action.value.submission.type.toUpperCase()}
                coverageType={coverages[action.value.submission.coverages.gl.base]}
            />,
            { autoClose: 10000 }
        );
    }
}

export default function* root() {
    yield takeEvery(SUBMISSION_EDIT_SUCCESS, submissionEditSuccess);
    yield takeEvery(SUBMISSION_CREATE_SUCCESS, submissionEditSuccess);
}
